<div class="page-actions">
  <dv-button
    color="primary"
    icon="add"
    (click)="onCreateClick()"
    routerLink="new/information"
    queryParamsHandling="preserve">
    {{ 'General.DamageReport' | translate | uppercase }}
  </dv-button>
</div>
<dv-vertical-splitter
  id="damage-reports-vertical-splitter"
  [resizableSide]="resizableSide.Right">
  <div left-side>
    <app-damage-reports-grid></app-damage-reports-grid>
  </div>
  <div right-side>
    <router-outlet />
  </div>
</dv-vertical-splitter>
